var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_2208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99918 0C3.58798 0 -0.000823975 3.58885 -0.000823975 8.00005C-0.000823975 12.4112 3.58798 16 7.99918 16C12.4104 16 15.9992 12.4112 15.9992 8.00005C15.9992 3.58885 12.4104 0 7.99918 0ZM7.99918 14.5455C4.38996 14.5455 1.45372 11.6092 1.45372 8.00005C1.45372 4.39088 4.38996 1.45455 7.99918 1.45455C11.6084 1.45455 14.5446 4.39088 14.5446 8.00005C14.5446 11.6092 11.6083 14.5455 7.99918 14.5455Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 3.39404C7.46476 3.39404 7.02985 3.82924 7.02985 4.36418C7.02985 4.89863 7.46476 5.33344 7.99935 5.33344C8.53394 5.33344 8.96885 4.89863 8.96885 4.36418C8.96885 3.82924 8.53394 3.39404 7.99935 3.39404Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99931 6.7876C7.59766 6.7876 7.27203 7.11322 7.27203 7.51487V11.8785C7.27203 12.2802 7.59766 12.6058 7.99931 12.6058C8.40096 12.6058 8.72658 12.2802 8.72658 11.8785V7.51487C8.72658 7.11322 8.40096 6.7876 7.99931 6.7876Z",
    fill: "#A0A0A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_2208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.ca8e932e4198aeb8ef4be0a7861e9360.svg";
export { ForwardRef as ReactComponent };